import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get } from "../../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../../Components/Masters/MenuActions";
import TableContent from "../../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../../Roles and Permissions/Filters/MultiSelect";
import NoDataFound from "../../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../../Layout/MastersSidebar";
import ViewVehicle from "./ViewVehicle";
import AddVehicle from "./AddVehicle";
import Unauthorized from "../../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../../context/AuthContext";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  GRID_TABLE_ACTION_COL,
  getGridTableRowSx,
  gridTableActionHeaderSx,
  gridTablePaperSx,
  isFacilityHeading,
  shouldShowFacilityColumn,
  withFacilityHeading, FacilityDataCell, MasterDateDataCell } from "../../../../../utils/facilityColumn";

const Vehicle = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? `minmax(0, 0.9fr) minmax(0, 1fr) minmax(0, 1.1fr) minmax(0, 0.9fr) minmax(0, 0.9fr) minmax(0, 1.2fr) minmax(0, 1fr) ${GRID_TABLE_ACTION_COL}`
    : `minmax(0, 0.9fr) minmax(0, 1.2fr) minmax(0, 0.9fr) minmax(0, 0.9fr) minmax(0, 1.3fr) minmax(0, 1.1fr) ${GRID_TABLE_ACTION_COL}`;
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addVehicle, setAddVehicle] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    // "Transport Type": false,
    // Ownership: false,
    "Logistics Vendor": false,
    Brand: false,
    Model: false,
    "Vehicle Category": false,
    "Vehicle Type": false,
  });
  const [viewVehicle, setViewVehicle] = useState(false);
  const [vehicle, setVehicle] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    // "Transport Type": false,
    // Ownership: false,
    "Logistics Vendor": false,
    Brand: false,
    Model: false,
    "Vehicle Category": false,
    "Vehicle Type": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    logisticsVendor: [],
    brand: [],
    model: [],
    vehicleType: [],
    vehicleCategory: [],
  });
  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    logisticsVendor: [],
    brand: [],
    model: [],
    vehicleType: [],
    vehicleCategory: [],
  });

  const filters = [
    "Date",
    "Logistics Vendor",
    "Brand",
    "Model",
    "Vehicle Category",
    "Vehicle Type",
  ];
  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  const inputData = [
    // {
    //   fieldName: "transportType",
    //   title: "Transport type",
    //   options: ["Passenger", "Freight"],
    //   placeholder: "Tap to select",
    // },
    // {
    //   fieldName: "ownership",
    //   title: "Ownership",
    //   options: ["Company owned", "Leased"],
    //   placeholder: "Tap to select",
    // },
    {
      fieldName: "logisticsVendor",
      title: "Logistics Vendor",
      type: "select",
      url: `${api}/master/logistic/vendorMaster`,
      field: "logisticVendorLegalName",
    },
    {
      fieldName: "vehicleNumber",
      title: "Vehicle Number",
      placeholder: "Enter Vehicle Number",
    },
    {
      fieldName: "vehicleCategory",
      title: "Vehicle Category",
      options: [
        "Heavy Commercial Vehicles (HCV)",
        "Medium Commerical Vehicles (MCV)",
        "Light Commerical Vehicles (LCV)",
      ],
      type: "select",
    },
    {
      fieldName: "vehicleType",
      title: "Vehicle Type",
      type: "select",
    },
    {
      fieldName: "brand",
      title: "Brand",
      // type: "select",
      placeholder: "Enter Brand",
      // url:`${api}/master/getAllBrand`
    },
    {
      fieldName: "model",
      title: "Model",
      // type: "select",
      placeholder: "Enter Model",
      // url:`${api}/master/getAllModel`
    },
    {
      fieldName: "bharatStageEmissionType",
      title: "Bharat Stage Emission Type",
      options: [
        "India 2000 (Euro 1)",
        "BS II (Euro 2)",
        "BS III (Euro 3)",
        "BS IV (Euro 4)",
        "BS V (Euro 5)",
        "BS VI (Euro 6)",
      ],
      type: "select",
    },
    {
      fieldName: "purchaseDate",
      title: "Purchase Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "lastServiceDate",
      title: "Last Service Date",
      type: "date",
      placeholder: "dd/mm/yyyy",
    },
    {
      fieldName: "fuelType",
      title: "Fuel Type",
      options: [
        "Diesel (average biofuel blend)",
        "Diesel (100% mineral diesel)",
        "Petrol (average biofuel blend)",
        "Petrol (100% mineral petrol)",
        "CNG",
        "Electricity",
      ],
      type: "select",
    },
    {
      fieldName: "declaredEfficiency",
      title: "Declared Efficiency",
      placeholder: "Enter Number",
      type: "number",
    },
    {
      fieldName: "loadCapacity",
      title: "Load Capacity (tonnes)",
      placeholder: "Enter Number",
    },
    { fieldName: "uploadDocuments", title: "Upload Documents" },
    { fieldName: "pucDocs", title: "PUC Docs" },
    { fieldName: "pollutionDocs", title: "Pollution Docs" },
    { fieldName: "rcDocs", title: "RC Docs" },
    { fieldName: "insuranceDocs", title: "Insurance Docs" },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/master/getAllVehicle`);
      const vehicles = response.data.data;
      console.log(vehicles);

      const uniqueModels = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.model).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueBrands = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.brand).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVehicleTypes = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.vehicleType).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVehicleCategory = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.vehicleCategory).filter(Boolean) // Filter out undefined values
        ),
      ];
      const uniqueVendors = [
        ...new Set(
          vehicles.map((vehicle) => vehicle.logisticsVendor).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        models: uniqueModels,
        brands: uniqueBrands,
        vendors: uniqueVendors,
        vehicleCategory: uniqueVehicleCategory,
        vehicleType: uniqueVehicleTypes,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    console.log(filters, sortConfig.key, sortConfig.direction);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
      }).toString();
      const response = await get(`/master/getAllVehicle?${queryParams}`);

      setData(response.data.data); // Update the user list
      console.log(response.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
      console.log(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, vehicle) => {
    setAnchorEl(event.currentTarget);
    setSelectedVehicle(vehicle);
    setVehicle(vehicle);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedVehicle(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddVehicle(true);
    setViewVehicle(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewVehicle(true);
    setAddVehicle(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    logisticsVendor: tempFilter?.logisticsVendor
      ? tempFilter?.logisticsVendor
      : "",
    vehicleCategory: tempFilter?.vehicleCategory
      ? tempFilter?.vehicleCategory
      : "",
    vehicleType: tempFilter?.vehicleType ? tempFilter?.vehicleType : "",
    brand: tempFilter?.brand ? tempFilter?.brand : "",
    model: tempFilter?.model ? tempFilter?.model : "",
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    setPage(1);
    fetchData(filtersToApply);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      logisticsVendor: tempFilter?.logisticsVendor
        ? tempFilter?.logisticsVendor
        : [],
      brand: tempFilter?.brand ? tempFilter?.brand : [],
      model: tempFilter?.model ? tempFilter?.model : [],
      vehicleType: tempFilter?.vehicleType ? tempFilter?.vehicleType : [],
      vehicleCategory: tempFilter?.vehicleCategory
        ? tempFilter?.vehicleCategory
        : [],
    });
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    // Reset local state for date selection and selected fields
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      logisticsVendor: [],
      brand: [],
      model: [],
      vehicleType: [],
      vehicleCategory: [],
    });
    setTempFilter({
      startDate: null,
      endDate: null,
      logisticsVendor: [],
      brand: [],
      model: [],
      vehicleType: [],
      vehicleCategory: [],
    });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied =
      tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isVehicleTypeApplied =
      tempFilter?.vehicleType?.length > 0 ? true : false;
    const isVehicleCategoryApplied =
      tempFilter?.vehicleCategory?.length > 0 ? true : false;
    const isLogisticsVendorApplied =
      tempFilter?.logisticsVendor?.length > 0 ? true : false;
    const isBrandApplied = tempFilter?.brand?.length > 0 ? true : false;
    const isModelApplied = tempFilter?.model?.length > 0 ? true : false;

    setIsFiltersApplied(
      isDateApplied ||
        isVehicleTypeApplied ||
        isVehicleCategoryApplied ||
        isLogisticsVendorApplied ||
        isBrandApplied ||
        isModelApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Vehicle Type": isVehicleTypeApplied,
      "Vehicle Category": isVehicleCategoryApplied,
      "Logistics Vendor": isLogisticsVendorApplied,
      Brand: isBrandApplied,
      Model: isModelApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDates: endDate,
      logisticsVendor: selectedFields?.logisticsVendor,
      brand: selectedFields?.brand,
      model: selectedFields?.model,
      vehicleCategory: selectedFields?.vehicleCategory,
      vehicleType: selectedFields?.vehicleType,
    });
    setDrawerFilterOpen(false);
    setErrors({
      Date: false,
      Brand: false,
      Model: false,
      "Vehicle Category": false,
      "Vehicle Type": false,
    });
  };

  const columnHeadings = withFacilityHeading(
    [
      { title: "Date", field: "createdAt" },
      { title: "Logistics Vendor", field: "logisticsVendor" },
      { title: "Brand", field: "brand" },
      { title: "Model", field: "model" },
      { title: "Vehicle Category", field: "vehicleCategory" },
      { title: "Vehicle Type", field: "vehicleType" },
    ],
    showFacilityColumn,
    "field"
  );

  // Function to render the selected filter component based on user's choice
  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Model":
        return (
          <MultiSelect
            title="Model"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  model: newValue.model || newValue,
                };
              });
            }}
            errors={errors.Model}
            setErrors={setErrors}
            field="model"
            data={uniqueValues.models}
          />
        );
      case "Brand":
        return (
          <MultiSelect
            title="Brand"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  brand: newValue.brand || newValue,
                };
              });
            }}
            errors={errors.Brand}
            setErrors={setErrors}
            field="brand"
            data={uniqueValues.brands}
          />
        );
      case "Logistics Vendor":
        return (
          <MultiSelect
            title="Logistics Vendor"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  logisticsVendor: newValue.logisticsVendor || newValue,
                };
              });
            }}
            errors={errors["Logistics Vendor"]}
            setErrors={setErrors}
            field="logisticsVendor"
            data={uniqueValues.vendors}
          />
        );
      case "Vehicle Category":
        return (
          <MultiSelect
            title="Vehicle Category"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  vehicleCategory: newValue.vehicleCategory || newValue,
                };
              });
            }}
            errors={errors["Vehicle Category"]}
            setErrors={setErrors}
            field="vehicleCategory"
            data={uniqueValues.vehicleCategory}
          />
        );
      case "Vehicle Type":
        return (
          <MultiSelect
            title="Vehicle Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  vehicleType: newValue.vehicleType || newValue,
                };
              });
            }}
            errors={errors["Vehicle Type"]}
            setErrors={setErrors}
            field="vehicleType"
            data={uniqueValues.vehicleType}
          />
        );
      default:
        return null;
    }
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          {/*Message popup for success or failure */}
          {/* View log, Edit, delete menus */}
          <AddVehicle
            id={vehicle ? vehicle._id : ""}
            addData={addVehicle}
            setAddData={setAddVehicle}
            data={data}
            element={vehicle}
            addUrl={`${api}/master/addVehicle`}
            updateUrl={`${api}/master/updateVehicle`}
            // details={vehicle}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewVehicle
            id={vehicle ? vehicle._id : ""}
            data={vehicle}
            viewData={viewVehicle}
            setViewData={setViewVehicle}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: vehicle._id,
                url: `${api}/master/deleteVehicle`,
                method: "put",
                setsnackOpen,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenu
            setData={setVehicle}
            setAddData={setAddVehicle}
            {...{
              heading: "Scope 3", //Transportation & Distribution
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ ...gridTablePaperSx, overflowX: "hidden" }}
          >
            <Box sx={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
              <TableHeading heading={"Vehicle Master"} />
              <Box
                sx={{
                  ...getGridTableRowSx(columnWidth),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) =>
                  isFacilityHeading(el) ? (
                    <FacilityColumnHeading
                      key={el.field}
                      handleSort={handleSort}
                      sortConfig={sortConfig}
                    />
                  ) : (
                    <ColumnHeadings
                      key={el.field}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.field,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography sx={gridTableActionHeaderSx}>Action</Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data.map((Vehicle) => (
                  <Box
                    key={Vehicle._id}
                    sx={{
                      ...getGridTableRowSx(columnWidth),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) =>
                      isFacilityHeading(el) ? (
                        <FacilityDataCell key={el.field}>
                          {getFacilityName(Vehicle) || "N/A"}
                        </FacilityDataCell>
                      ) : (
                        <TableContent
                          key={el.field}
                          {...{
                            fieldData:
                              el.field === "logisticsVendor"
                                ? Vehicle.logisticsVendor
                                : typeof Vehicle[el.field] === "object" &&
                                  Vehicle[el.field] !== null
                                ? Vehicle[el.field]
                                : Vehicle[el.field],
                            dateField:
                              el.field === "createdAt"
                                ? Vehicle.createdAt
                                : false,
                          }}
                        />
                      )
                    )}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: Vehicle }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent} // Pass this state to PaginationBox
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: Vehicle._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Vehicle;
